import { useRegionContext } from "../../../../Regions/contexts/RegionContext.js";
import { SelectUser } from "../../../../Users/shared/SelectUser.js";
import { SelectLocation } from "../../../../Locations/shared/SelectLocation.js";
import { SelectEvent } from "../../SelectEvent.js";
import { SelectReport } from "../../../../Reports/shared/SelectReport.js";
import { SelectRecord } from "../../../../Records/shared/SelectRecord.js";
import { SelectLocationLogEntry } from "../../../../Locations/shared/LocationLogEntries/SelectLocationLogEntry.js";
import "react";
import { Button, Label } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/Events/shared/CreateEventForm/components/EventRefsFields.tsx
function EventRefsFields({ allowedRefs = {}, onChangeValue, value = {} }) {
	const handleRefChange = (key, newValue) => {
		onChangeValue({
			...value,
			[key]: newValue
		});
	};
	const regionCtx = useRegionContext();
	return /* @__PURE__ */ jsxs("div", {
		className: "gap-y-lg flex flex-col",
		children: [
			/* @__PURE__ */ jsxs("div", { children: [/* @__PURE__ */ jsx(Label, { children: "Add Event References" }), /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx("small", {
				className: "text-color-neutral",
				children: "References create a link to the Event. Any and all associations or relevant refs should be added below."
			}) })] }),
			allowedRefs.events && /* @__PURE__ */ jsxs("div", { children: [/* @__PURE__ */ jsx("div", {
				className: "mb-3",
				children: /* @__PURE__ */ jsx(Label, { children: "Events" })
			}), Array.isArray(value?.eventIds) ? /* @__PURE__ */ jsx(SelectEvent, {
				multi: true,
				onChangeValue: (val) => handleRefChange("eventIds", val),
				regionIds: regionCtx?.regionId ? [regionCtx.regionId] : void 0,
				value: value.eventIds
			}) : /* @__PURE__ */ jsx(Button, {
				onClick: () => handleRefChange("eventIds", []),
				subtle: true,
				children: "+ Add Refs"
			})] }),
			allowedRefs.locations && /* @__PURE__ */ jsxs("div", { children: [/* @__PURE__ */ jsx("div", {
				className: "mb-3",
				children: /* @__PURE__ */ jsx(Label, { children: "Locations" })
			}), Array.isArray(value?.locationIds) ? /* @__PURE__ */ jsx(SelectLocation, {
				multi: true,
				onChangeValue: (val) => handleRefChange("locationIds", val),
				regionIds: regionCtx?.regionId ? [regionCtx.regionId] : void 0,
				value: value.locationIds
			}) : /* @__PURE__ */ jsx(Button, {
				onClick: () => handleRefChange("locationIds", []),
				subtle: true,
				children: "+ Add Refs"
			})] }),
			allowedRefs.locationLogEntries && /* @__PURE__ */ jsxs("div", { children: [/* @__PURE__ */ jsx("div", {
				className: "mb-3",
				children: /* @__PURE__ */ jsx(Label, { children: "Location Log Entries" })
			}), Array.isArray(value?.locationLogEntryIds) && Array.isArray(value.locationIds) ? /* @__PURE__ */ jsx(SelectLocationLogEntry, {
				disabled: !value.locationIds[0],
				hint: !value.locationIds[0] ? "Select a Location Ref" : void 0,
				locationId: value.locationIds[0],
				multi: true,
				onChangeValue: (val) => handleRefChange("locationLogEntryIds", val),
				value: value.locationLogEntryIds
			}) : /* @__PURE__ */ jsx(Button, {
				onClick: () => handleRefChange("locationLogEntryIds", []),
				subtle: true,
				children: "+ Add Refs"
			})] }),
			allowedRefs.records && /* @__PURE__ */ jsxs("div", { children: [/* @__PURE__ */ jsx("div", {
				className: "mb-3",
				children: /* @__PURE__ */ jsx(Label, { children: "Records" })
			}), Array.isArray(value?.recordIds) ? /* @__PURE__ */ jsx(SelectRecord, {
				multi: true,
				onChangeValue: (val) => handleRefChange("recordIds", val),
				regionIds: regionCtx?.regionId ? [regionCtx.regionId] : void 0,
				value: value.recordIds
			}) : /* @__PURE__ */ jsx(Button, {
				onClick: () => handleRefChange("recordIds", []),
				subtle: true,
				children: "+ Add Refs"
			})] }),
			allowedRefs.reports && /* @__PURE__ */ jsxs("div", { children: [/* @__PURE__ */ jsx("div", {
				className: "mb-3",
				children: /* @__PURE__ */ jsx(Label, { children: "Reports" })
			}), Array.isArray(value?.reportIds) ? /* @__PURE__ */ jsx(SelectReport, {
				multi: true,
				onChangeValue: (val) => handleRefChange("reportIds", val),
				regionIds: regionCtx?.regionId ? [regionCtx.regionId] : void 0,
				value: value.reportIds
			}) : /* @__PURE__ */ jsx(Button, {
				onClick: () => handleRefChange("reportIds", []),
				subtle: true,
				children: "+ Add Refs"
			})] }),
			allowedRefs.users && /* @__PURE__ */ jsxs("div", { children: [/* @__PURE__ */ jsx("div", {
				className: "mb-3",
				children: /* @__PURE__ */ jsx(Label, { children: "Users" })
			}), Array.isArray(value?.userIds) ? /* @__PURE__ */ jsx(SelectUser, {
				multi: true,
				onChangeValue: (val) => handleRefChange("userIds", val),
				regionIds: regionCtx?.regionId ? [regionCtx.regionId] : void 0,
				value: value.userIds
			}) : /* @__PURE__ */ jsx(Button, {
				onClick: () => handleRefChange("userIds", []),
				subtle: true,
				children: "+ Add Refs"
			})] })
		]
	});
}
//#endregion
export { EventRefsFields };

//# sourceMappingURL=EventRefsFields.js.map